import { MapsAPILoader } from "@agm/core";
import { Component, Input, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { MDBModalRef, MDBModalService } from "angular-bootstrap-md";
import {
  InstaCitiCountries,
  InstaNearByLocality,
  InstaPopularCity,
} from "../instaciti-new.interface";
import { InstacitiSupportComponent } from "../instaciti-support/instaciti-support.component";
import { InstacitiNewService } from "../service/instaciti-new.service";
declare function Tooltip(): any;
@Component({
  selector: "portal-instaciti-header",
  templateUrl: "./instaciti-header.component.html",
  styleUrls: ["./instaciti-header.component.css"],
})
export class InstacitiHeaderComponent implements OnInit {
  @Input() isHome: boolean = true;
  selectedKeyWord = { Keywd: "" };
  logoURL: string = "../../../../assets/instaciti-new-img/instaciti_beta 1.svg";
  countries: InstaCitiCountries[] = [];
  location: string;
  cities = [];
  popularCities: InstaPopularCity[] = [];
  selectedCountry;
  locationDetected: boolean = false;
  nearby: InstaNearByLocality[] = [];
  selectedCity;
  latitude: number;
  longitude: number;
  searchResult: [];
  zoom: number;
  address: string;
  searchText: string;
  private geoCoder;
  modalRef: MDBModalRef;
  constructor(
    private service: InstacitiNewService,
    private modalService: MDBModalService,
    private route: Router,
    private mapsAPILoader: MapsAPILoader,
    private routeParam: ActivatedRoute
  ) {}

  ngOnInit(): void {
    setTimeout(() => {
      Tooltip();
    }, 400);

    this.getCountries();
    this.service.instaSubject.subscribe((res) => {
      if (res) {
        let json0 = this.service.getGlobalJson0();
        // this.logoURL = json0[0].LogoURL;
      }
    });
    this.searchText = this.routeParam.snapshot.params["locality"]
      ? this.routeParam.snapshot.params["locality"]
      : "";
    this.searchText = this.searchText.replace("-", " ");
    this.location = this.searchText;
  }

  selectCountry(country) {
    this.selectedCountry = country;
    this.service.locationSubject.next(country.CountryName);
    this.service.setSelectedCountry(this.selectedCountry);
    this.service.selectedCountrySubject.next(this.selectedCountry);
    sessionStorage.setItem("PortalDS", this.selectedCountry.CountryDBContext);
    this.service.GetPopularCities(country).subscribe((res) => {
      this.popularCities = res.ManikJSon[0].JSon0;
      this.service.popularCitiesSubject.next(this.popularCities);
    });
    this.service.getLocationMetaData(this.searchText).subscribe((res) => {
      this.selectedCity = res.ManikJSon[0].JSon0[0];
      this.service.selectedCitySubject.next(this.selectedCity);
    });
  }

  getCountries() {
    this.service.GetCountries().subscribe((res) => {
      this.countries = res.ManikJSon[0].JSon0;
      this.mapsAPILoader.load().then(() => {
        if ("geolocation" in navigator) {
          navigator.geolocation.getCurrentPosition((position) => {
            this.locationDetected = true;
            this.latitude = position.coords.latitude;
            this.longitude = position.coords.longitude;
            this.zoom = 8;
            this.geoCoder = new google.maps.Geocoder();
            this.geoCoder.geocode(
              { location: { lat: this.latitude, lng: this.longitude } },
              (results, status) => {
                if (status === "OK") {
                  console.log(results);
                  if (results[0]) {
                    this.zoom = 12;
                    this.address = results[0].formatted_address;
                    var arr = this.address.split(",");
                    if (arr.length) {
                      this.selectCountry(
                        this.countries.find((c) =>
                          c.CountryName.includes(arr[arr.length - 1].trim())
                        )
                      );
                    } else {
                      this.selectCountry(
                        this.countries.find((c) => c.CountryID === 100000)
                      );
                    }
                    this.location = this.searchText;
                  } else {
                    window.alert("No results found");
                  }
                } else {
                  window.alert("Geocoder failed due to: " + status);
                }
              }
            );
          });
        }
      });
    });
  }
  selectLocation(event: any) {
    switch (event.target.value) {
      case "0":
        this.setCurrentLocation();
        break;
      case "-1":
        break;
      default:
        if (this.locationDetected) {
          this.selectedCity = this.nearby.find(
            (element) => element.CityID === parseInt(event.target.value)
          );
        } else {
          this.selectedCity = this.popularCities.find(
            (element) => element.CityID === parseInt(event.target.value)
          );
        }
        console.log(this.selectedCity);
        break;
    }
  }
  setCurrentLocation() {
    this.mapsAPILoader.load().then(() => {
      if ("geolocation" in navigator) {
        navigator.geolocation.getCurrentPosition((position) => {
          this.locationDetected = true;
          this.latitude = position.coords.latitude;
          this.longitude = position.coords.longitude;
          this.zoom = 8;
          this.getAddress(this.latitude, this.longitude);
        });
      }
      this.geoCoder = new google.maps.Geocoder();
    });
  }
  getAddress(latitude, longitude) {
    this.geoCoder.geocode(
      { location: { lat: latitude, lng: longitude } },
      (results, status) => {
        if (status === "OK") {
          console.log(results);
          if (results[0]) {
            this.zoom = 12;
            this.address = results[0].formatted_address;
            var arr = this.address.split(",");
            if (arr.length > 1) {
              this.searchText = arr[arr.length - 2].concat(
                ",",
                arr[arr.length - 1]
              );
            } else {
              this.searchText = this.address;
            }
            this.location = this.searchText;
          } else {
            window.alert("No results found");
          }
        } else {
          window.alert("Geocoder failed due to: " + status);
        }
      }
    );
  }
  getNearBy() {
    this.service
      .GetNearByLocalities({
        CountryID: this.selectedCountry.CountryID,
        Latitude: this.latitude ? this.latitude : this.selectedCountry.Latitude,
        Longitude: this.longitude
          ? this.longitude
          : this.selectedCountry.Longitude,
        portalds: this.selectedCountry.CountryDBContext,
        SearchText: this.searchText || "",
      })
      .subscribe((res) => {
        this.nearby = res.ManikJSon[0].JSon0.length
          ? res.ManikJSon[0].JSon0.slice(0, 20)
          : [];
      });
  }
  search(event: any) {
    const keyword = event.target.value;
    this.service
      .SearchByKeyword(
        this.selectedCity ? this.selectedCity : this.selectedCountry,
        keyword.trim()
      )
      .subscribe((res) => {
        this.searchResult = res.ManikJSon[0].JSon0.length
          ? res.ManikJSon[0].JSon0.slice(0, 50)
          : [];
      });
  }

  support() {
    this.modalRef = this.modalService.show(InstacitiSupportComponent, {
      backdrop: true,
      keyboard: false,
      ignoreBackdropClick: true,
      data: {
        CountriesList: this.countries,
        SelectedCountryID: this.selectedCountry.CountryID,
      },
    });
  }
  selectNearByCity(city) {
    this.selectedCity = city;
    this.location = city.LocName;
    this.searchText = city.LocName;
    let locn = location.pathname.replace(
      this.routeParam.snapshot.params["locality"],
      this.selectedCity.URLName.trim()
    );
    this.route.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
    this.route.navigateByUrl(locn);
  }
  selectPopularCity(city) {
    this.selectedCity = city;
    this.location = city.CityName;
    this.searchText = city.CityName;
    let locn = location.pathname.replace(
      this.routeParam.snapshot.params["locality"],
      this.selectedCity.URLName.trim()
    );
    this.route.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
    this.route.navigateByUrl(locn);
  }
  onChange(item) {
    this.selectedKeyWord = item;
    if (item.Tgt === "S") {
      this.route.routeReuseStrategy.shouldReuseRoute = function () {
        return false;
      };
      this.route.navigateByUrl(
        this.selectedCity.URLName.trim() + "/" + item.URL
      );
    } else if (item.Tgt === "N") {
      this.GoToBizSpot(item.URL);
    }
  }
  GoToBizSpot(url) {
    window.open(url, "_blank");
  }
}
